module.exports = __webpack_public_path__ + "img/25_newModelWorker_zfy.4f4503da.png";